<template>
  <div>
    <div class="container vertical-align login escolha mt-4 text-center">
      <div v-if="titular">
        <h2>Agora vamos verificar o seu {{ validationMethodText }}</h2>
      </div>
      <div v-else>
        <h2>Agora vamos verificar o {{ validationMethodText }} de {{ dependente.nome.split(' ')[0]}}</h2>
      </div>
      <h4>
        Digite o código de confirmação que enviamos por {{ validationMethodText }} para {{ validationAddress }}.
      </h4>
      <div class="row">
        <form @submit.prevent="validateCode()" class="form-signin">
          <div>
            <div class="relative mt-4">
              <input
                type="tel"
                required="true"
                maxlength="6"
                v-model="validationCode"
                class="codigoConfirmacao form-control"
                id="codigoValidacao"
              />
            </div>
          </div>

          <div class="row">
            <div class="col">
              <g-recaptcha
                data-sitekey="6LcQB_EUAAAAAPGeh3IGuaY5gWca1ig2BzQOsODm"
                :data-validate="() => true"
                :data-callback="sendNewVerificationCode"
                data-btn-class="btn mt-4"
                v-show="!isVerificationCodeOnCountDown"
              >
                Reenviar código
              </g-recaptcha>
              <button
                type="button"
                class="mt-4 btn"
                v-show="isVerificationCodeOnCountDown"
                :disabled="true"
              >
                Reenviar código
              </button>
            </div>
            <div class="col">
              <button
                class="btn btn-lg btn-primary btn-block button success mt-4"
                type="submit"
              >
                Confirmar
              </button>
            </div>
          </div>
          <div class="row" v-show="verificationCodeCountDown != 0">
            <div class="col text-center mt-4">
              Caso não receba, solicite um novo código em {{ verificationCodeCountDown }} segundos
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import ValidacaoMixins from "@/mixins/validacao.mixins.js";
import gRecaptcha from "@finpo/vue2-recaptcha-invisible";

export default {
  name: "ValidarCodigo",
  props: ["tipoDeUsuario", "indiceDependente"],
  components: { gRecaptcha },
  mounted() {
    this.startCountDown();
  },
  data: () => ({
    verificationCodeCountDown: 0,
    validationCode: "",
  }),
  mixins: [ValidacaoMixins],
  methods: {
    validateCode() {
      this.$conexaApi
        .post(`/confirmacao_dados_usuario/confirmar_${this.validationMethod}`, {
          pacienteId: this.idUsuario,
          token: this.validationCode,
        })
        .then((res) => {
          if (res.data.confirmado) {
            this.cadastrarSenha();
          } else {
            this.$notify({
              group: "mensagens",
              text: `Código inválido`,
              type: "error",
            });
          }
        })
        .catch((error) => {
          this.$notify({
            group: "mensagens",
            text:
              (error.response &&
                error.response.data &&
                error.response.data.msg) ||
              `Ocorreu um erro ao validar o código`,
            type: "error",
          });
        })
        .finally(() => {
          // NProgress.done();
        });
    },
    startCountDown() {
      this.verificationCodeCountDown = 60; // pegar do session storage
      const counter = setInterval(() => {
        if (this.verificationCodeCountDown > 0) {
          this.verificationCodeCountDown -= 1; // gravar no session storage para o caso de refresh ou mudança na rota
        } else {
          clearTimeout(counter);
        }
      }, 1000);
    },
    sendNewVerificationCode(captcha) {
      this.sendValidationCode(this.validationMethod, captcha)
        .then(() => {
          this.$notify({
            group: "mensagens",
            text: `Um novo código foi enviado para seu ${
              this.validationMethodText
            }.`,
            type: "success",
          });
          this.startCountDown();
        })
        .catch(() => {
          this.$notify({
            group: "mensagens",
            text: `Ocorreu um erro ao enviar o código para o seu ${
              this.validationMethod
            }`,
            type: "error",
          });
        });
    },
    cadastrarSenha() {
      if (this.titular) {
        this.$router.push("/cadastrar-senha/titular");
      } else {
        location.href = `/cadastrar-senha/dependente/${this.indiceDependente}`;
      }
    },
  },
  computed: {
    validationMethodText() {
      if (this.validationMethod === "email") return "e-mail";
      return "número de telefone";
    },
     idDependente() {
      return this.dependente.idDependente;
    },
     dependente() {
      if (this.indiceDependente === undefined) return null
      const dependentes = JSON.parse(sessionStorage.getItem("dependentes"));
      const dependente = dependentes[parseInt(this.indiceDependente)];
      return dependente;
    },
    idUsuario() {
      return this.titular ? this.idPaciente : this.idDependente;
    },
    validationAddress() {
      if (this.validationMethod === "email") return this.email;
      return this.celular;
    },
    validationMethod() {
      return this.$route.query.validationMethod;
    },
    isVerificationCodeOnCountDown() {
      return this.verificationCodeCountDown !== 0;
    },
    titular() {
      return this.tipoDeUsuario === "titular";
    },
  },
};
</script>

<style scoped>
form,
button {
  margin: auto;
}
.codigoConfirmacao {
  border: 1px solid #4eb4e7;
  font: 3ch consolas, monospace;
  letter-spacing: 0.5ch;
  text-align: center;
  color: #4eb4e7;
}
.button {
  border: none;
  background: none;
  cursor: pointer;
}
</style>
